import { FontManager } from "@samuelmeuli/font-manager";

export const addDuplicateFontStyles = () => {
    let fontsUpdated = 0;
    // Find any font styles in the head where the font-family has a space in it, duplicate the style and remove the spaces from the font-family in the duplicate. This is because Google Fonts returns font-family names with spaces, but we want to use them without spaces in our code for simplicity.
    const fontStyles = document.querySelectorAll('style');
    fontStyles.forEach((style) => {
        if (style.innerHTML.includes('font-family') && style.innerHTML.match(/font-family:\s*['"]?([^;'"]+)['"]?;/)) {
            const fontFamilyMatch = style.innerHTML.match(/font-family:\s*['"]?([^;'"]+)['"]?;/);
            if (fontFamilyMatch) {
                const originalFontFamily = fontFamilyMatch[1];
                console.log(`Found font-family: ${originalFontFamily} in style:`, style);
                if (originalFontFamily.includes(' ')) {
                    const newFontFamily = originalFontFamily.split(' ').join('');
                    // Check if a style with the new font-family already exists to avoid duplicates
                    const existingStyle = Array.from(document.querySelectorAll('style')).find(s => s.innerHTML.includes(`font-family: ${newFontFamily};`));
                    if (!existingStyle) {
                        const newStyle = document.createElement('style');
                        newStyle.innerHTML = style.innerHTML.replace(new RegExp(`font-family:\\s*['"]?${originalFontFamily}['"]?;`, 'g'), `font-family: ${newFontFamily};`);
                        document.head.appendChild(newStyle);
                        console.log(`Added new style for font-family: ${newFontFamily}`);
                        fontsUpdated += 1;
                    }
                }
            }
        }
    });
    console.log(`Total fonts updated: ${fontsUpdated}`);
    if (fontsUpdated < 10) {
        console.warn('Less than 10 fonts were updated. This may indicate an issue with the font styles. Please check the console logs for details.');
        setTimeout(() => {
            addDuplicateFontStyles();
        }, 500);
    }
}

export const initGoogleFonts = () => {
    if (window.google && window.google.fonts) {
        return;
    }

    const fontManager = new FontManager("AIzaSyCK-FT-TdFUvWTWBQ_hxsoU_HS6GHeytWg", "Roboto", {
        pickerId: "icastGoogleFontsPicker",
        limit: 100,
    });
    fontManager.init().then(() => {
        console.log("Google Fonts initialized");
        console.log("Available fonts:", fontManager.getFonts());

        addDuplicateFontStyles();
    }).catch((error) => {
        console.error("Error initializing Google Fonts:", error);
    });

    window.google = {
        fonts: {
            load: () => {
                console.log('Google Fonts loaded');
            }
        }
    };
}
